import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/b2183ee2fcd384388309753581a9762c.jpg" 
          alt="Hero Background" 
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center w-full">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          {t('hero.title')}
        </h1>
        
        <p className="text-xl text-white/90 mb-10 max-w-3xl mx-auto leading-relaxed">
          {t('hero.subtitle')}
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button 
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-orange-500 text-white px-8 py-4 rounded-xl font-semibold hover:bg-orange-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            {t('hero.cta.primary')}
          </button>
          <button 
            onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-xl font-semibold border-2 border-white/30 hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
          >
            {t('hero.cta.secondary')}
          </button>
        </div>

        <div className="mt-16 flex flex-wrap justify-center items-center gap-8 text-white/80">
          <div className="flex items-center gap-2">
            <i className="ri-award-line text-2xl text-orange-400"></i>
            <span className="text-sm font-medium">{t('hero.badge.experience')}</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-user-heart-line text-2xl text-orange-400"></i>
            <span className="text-sm font-medium">{t('hero.badge.clients')}</span>
          </div>
        </div>
      </div>
    </section>
  );
}
